import { render } from "./MustChangePassword.vue?vue&type=template&id=323fea5f"
import script from "./MustChangePassword.vue?vue&type=script&lang=js"
export * from "./MustChangePassword.vue?vue&type=script&lang=js"
script.render = render

export default script